export default "__VITE_ASSET__DJFXywc0__"